/**
 * Shenja e autobusit ne harte.
 *
 * Me pare perdoreshin gjashte PNG te zgjedhura sipas pozicionit ne liste:
 * i njejti autobus ndryshonte ngjyre sapo ndryshonte rendi, dhe secila peshonte
 * rreth 190 KB e shfaqej e turbullt ne 55 piksel.
 *
 * Tani vizatohet ne vend, dhe ngjyra vjen nga id-ja e autobusit — pra mbetet
 * e njejta pergjithmone.
 */

/**
 * Ngjyra te dallueshme edhe mbi pamje satelitore: te ngopura, pa jeshile te
 * erreta qe humbasin mbi bimesi, pa verdhe te zbehte qe humbet mbi beton.
 */
const NGJYRAT = [
  '#E53935', // e kuqe
  '#1E88E5', // blu
  '#43A047', // jeshile
  '#FB8C00', // portokalli
  '#8E24AA', // vjollce
  '#00897B', // bruz
  '#D81B60', // rozë e thelle
  '#3949AB', // indigo
  '#6D4C41', // kafe
  '#546E7A', // gri-blu
];

/** E njejta id jep gjithmone te njejten ngjyre. */
export function busColor(busId) {
  const n = Number(busId);
  if (!Number.isFinite(n)) return NGJYRAT[0];

  return NGJYRAT[Math.abs(Math.trunc(n)) % NGJYRAT.length];
}

/**
 * Shenje harte me autobusin brenda, si data-URI.
 *
 * @param {number|string} busId  id e autobusit — percakton ngjyren
 * @param {string} [label]       teksti i vogel nen shenje, p.sh. numri i autobusit
 */
export function busIcon(busId, label = '') {
  const c = busColor(busId);
  const teksti = String(label || '').trim().slice(0, 6);

  // Konturi i bardhe e ndan shenjen nga sfondi, qofte asfalt apo bar.
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="46" height="${teksti ? 66 : 58}" viewBox="0 0 46 ${teksti ? 66 : 58}">
  <g>
    <path d="M23 56 C23 56 7 38 7 24 A16 16 0 0 1 39 24 C39 38 23 56 23 56 Z"
          fill="${c}" stroke="#fff" stroke-width="2.5" stroke-linejoin="round"/>
    <circle cx="23" cy="23" r="11.5" fill="#fff" opacity="0.95"/>
    <g fill="${c}">
      <rect x="15.5" y="15.5" width="15" height="12" rx="2.5"/>
      <rect x="17.5" y="17.5" width="11" height="5" rx="1" fill="#fff"/>
      <circle cx="18.5" cy="28.5" r="1.8"/>
      <circle cx="27.5" cy="28.5" r="1.8"/>
    </g>
  </g>
  ${
    teksti
      ? `<g><rect x="3" y="56" width="40" height="9" rx="4.5" fill="#fff" opacity="0.92"/>
         <text x="23" y="63" text-anchor="middle" font-family="system-ui,-apple-system,sans-serif"
               font-size="7.5" font-weight="700" fill="${c}">${escape_(teksti)}</text></g>`
      : ''
  }
</svg>`;

  return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
}

/** Madhesia qe i pergjigjet ikones, per `icon-size` te Leaflet-it. */
export function busIconSize(label = '') {
  return String(label || '').trim() ? [46, 66] : [46, 58];
}

/** Maja e shenjes rri mbi koordinaten, jo qendra. */
export function busIconAnchor(label = '') {
  return String(label || '').trim() ? [23, 56] : [23, 56];
}

function escape_(s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

export default { busIcon, busColor, busIconSize, busIconAnchor };
